import { SimpleListEntitiesAllowedEnum, SimpleListEntitiesResponseContent } from '@/api/resources/common/simple-list-entities/simple-list-entities.dto'
import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import i18n from '@/lang/i18n'
import { Nullable } from '@/shared/types/app.types'

export enum StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed {
    CASE_TYPE = 'CASE_TYPE',
    PRIORITY = 'PRIORITY',
    DESTINATION_HEALTH_MANAGEMENT_AREA = 'DESTINATION_HEALTH_MANAGEMENT_AREA',
    PHYSICIAN_CENTER = 'PHYSICIAN_CENTER',
    DESTINATION_CENTER = 'DESTINATION_CENTER',
    REGIME = 'REGIME',
    SAMPLE_TYPE = 'SAMPLE_TYPE',
    TOPOGRAPHIC_CODE = 'TOPOGRAPHIC_CODE',
    PORTION_TYPE = 'PORTION_TYPE',
    PROTOCOL = 'PROTOCOL',
    SUBPORTION_TYPE = 'SUBPORTION_TYPE',
    SUBPORTION_PRIORITY = 'SUBPORTION_PRIORITY',
    ASSAY = 'ASSAY',
    ASSAY_GROUP = 'ASSAY_GROUP'
}

export type StatisticalAnalysisViewDetailChartFilterByEnumAllowed =
    StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.CASE_TYPE |
    StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.PRIORITY |
    StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.DESTINATION_HEALTH_MANAGEMENT_AREA |
    StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.PHYSICIAN_CENTER |
    StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.DESTINATION_CENTER |
    StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.REGIME |
    StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.SAMPLE_TYPE |
    StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.TOPOGRAPHIC_CODE |
    StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.PORTION_TYPE |
    StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.PROTOCOL |
    StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.SUBPORTION_TYPE |
    StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.ASSAY |
    StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.ASSAY_GROUP

export interface StatisticalAnalysisViewDetailChartFiltersExtendedFilterMultiple {
    list: CommonPersonnelResponse[]
    selected: Nullable<CommonPersonnelResponse[]>
}

export interface StatisticalAnalysisSimpleListEntitiesResponseContentExtendedFilters extends SimpleListEntitiesResponseContent{
    entityId?: SimpleListEntitiesAllowedEnum
}

export interface StatisticalAnalysisViewDetailChartFiltersExtendedFilter {
    list: SimpleListEntitiesResponseContent[]
    selected: Nullable<StatisticalAnalysisSimpleListEntitiesResponseContentExtendedFilters>
}
export interface StatisticalAnalysisViewDetailChartFiltersExtendedFilters {
    mainFilter: StatisticalAnalysisViewDetailChartFiltersExtendedFilterMultiple
    filterBy: StatisticalAnalysisViewDetailChartFiltersExtendedFilter
    filterById: StatisticalAnalysisViewDetailChartFiltersExtendedFilter
}

export const StatisticalAnalysisViewDetailChartFilterByValuesBase =
    (): StatisticalAnalysisSimpleListEntitiesResponseContentExtendedFilters[] => [
        { id: StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.CASE_TYPE, label: i18n.tc('statisticalAnalysis.grids.caseType') },
        { id: StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.PRIORITY, label: i18n.tc('statisticalAnalysis.grids.priority') },
        { id: StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.DESTINATION_HEALTH_MANAGEMENT_AREA, label: i18n.tc('statisticalAnalysis.grids.destinationHealthManagementArea'), entityId: SimpleListEntitiesAllowedEnum.HEALTH_MANAGEMENT_AREA },
        { id: StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.PHYSICIAN_CENTER, label: i18n.tc('statisticalAnalysis.grids.requestingCenter'), entityId: SimpleListEntitiesAllowedEnum.CENTER },
        { id: StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.DESTINATION_CENTER, label: i18n.tc('statisticalAnalysis.grids.destinationCenter'), entityId: SimpleListEntitiesAllowedEnum.CENTER },
        { id: StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.REGIME, label: i18n.tc('statisticalAnalysis.grids.regime') }
    ]

export const StatisticalAnalysisViewDetailChartFilterByValuesSamples =
    (): StatisticalAnalysisSimpleListEntitiesResponseContentExtendedFilters[] => [
        { id: StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.SAMPLE_TYPE, label: i18n.tc('statisticalAnalysis.grids.sampleType') },
        { id: StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.TOPOGRAPHIC_CODE, label: i18n.tc('statisticalAnalysis.grids.topographicCode') }
    ]

export const StatisticalAnalysisViewDetailChartFilterByValuesPortions =
    (): StatisticalAnalysisSimpleListEntitiesResponseContentExtendedFilters[] => [
        { id: StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.PORTION_TYPE, label: i18n.tc('statisticalAnalysis.grids.portion.portionType') },
        { id: StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.PROTOCOL, label: i18n.tc('statisticalAnalysis.grids.portion.protocol') }
    ]

export const StatisticalAnalysisViewDetailChartFilterByValuesSubportions =
    (): StatisticalAnalysisSimpleListEntitiesResponseContentExtendedFilters[] => [
        { id: StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.SUBPORTION_TYPE, label: i18n.tc('statisticalAnalysis.grids.subportion.subportionType') },
        { id: StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.SUBPORTION_PRIORITY, label: i18n.tc('statisticalAnalysis.grids.subportion.priority'), entityId: SimpleListEntitiesAllowedEnum.PRIORITY },
        { id: StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.ASSAY, label: i18n.tc('statisticalAnalysis.grids.subportion.assay') },
        { id: StatisticalAnalysisViewDetailChartFilterByEnumIdAllowed.ASSAY_GROUP, label: i18n.tc('statisticalAnalysis.grids.subportion.assayGroup'), entityId: SimpleListEntitiesAllowedEnum.ASSAYGROUP }
    ]

export interface StatisticalAnalysisViewDetailChartFiltersExtendedState {
    sidepanelVisible: boolean
    externalLoading: boolean
    loading: boolean
    filters: StatisticalAnalysisViewDetailChartFiltersExtendedFilters
}
export const initialStatisticalAnalysisViewDetailChartFiltersExtendedState =
    (): StatisticalAnalysisViewDetailChartFiltersExtendedState => ({
        sidepanelVisible: false,
        loading: false,
        externalLoading: false,
        filters: {
            mainFilter: {
                list: [],
                selected: null
            },
            filterBy: {
                list: [],
                selected: null
            },
            filterById: {
                list: [],
                selected: null
            }
        }
    })
